export const RETURN_TO_LAUNCH_MODES = {
    ALONG_PREVIOUS_POINTS: "along_previous_points",
    PLAN_TO_LAUNCH: "plan_to_launch",
    DYNAMIC: "dynamic",
};

export const RETURN_TO_LAUNCH_MODE_OPTIONS = [
    {
        value: RETURN_TO_LAUNCH_MODES.ALONG_PREVIOUS_POINTS,
        label: "Return along previous points",
    },
    {
        value: RETURN_TO_LAUNCH_MODES.PLAN_TO_LAUNCH,
        label: "Return by planning towards launch point",
    },
    {
        value: RETURN_TO_LAUNCH_MODES.DYNAMIC,
        label: "Return by layer (stairs then launch)",
    },
];

export const MISSION_FAILURE_MODES = {
    STOP_AND_HOLD: "stop_and_hold",
    RETURN_TO_LAUNCH: "return_to_launch",
    RETRY_FAILED_ACTION: "retry_failed_action",
};

export const MISSION_FAILURE_MODE_OPTIONS = [
    {
        value: MISSION_FAILURE_MODES.STOP_AND_HOLD,
        label: "Stop and hold position",
    },
    {
        value: MISSION_FAILURE_MODES.RETURN_TO_LAUNCH,
        label: "Return to launch",
    },
    {
        value: MISSION_FAILURE_MODES.RETRY_FAILED_ACTION,
        label: "Retry failed action",
    },
];

export const getReturnToLaunchModeLabel = (mode) =>
    RETURN_TO_LAUNCH_MODE_OPTIONS.find((option) => option.value === mode)?.label ?? null;

export const getMissionFailureModeLabel = (mode) =>
    MISSION_FAILURE_MODE_OPTIONS.find((option) => option.value === mode)?.label ?? null;
